// Bilingual safety content — HFACS-Eq / Eq-Safety Model aligned
// Each item: { id, de, en }

export const preRideSections = [
  {
    id: "horse",
    icon: "PawPrint",
    de: "Pferd",
    en: "Horse",
    items: [
      { id: "h1", de: "Allgemeinzustand: wach, gesund, keine Lahmheit erkennbar", en: "General condition: alert, healthy, no visible lameness" },
      { id: "h2", de: "Verhalten heute normal (kein untypischer Stress / Schmerz)", en: "Behaviour normal today (no atypical stress / pain)" },
      { id: "h3", de: "Hufe/Beschlag geprüft, sauber ausgekratzt", en: "Hooves / shoes checked, cleanly picked out" },
      { id: "h4", de: "Sattel & Trense passen, keine Druckstellen", en: "Saddle & bridle fit, no pressure points" },
      { id: "h5", de: "Gurt korrekt, Riemen & Schnallen intakt", en: "Girth correct, straps & buckles intact" },
    ],
  },
  {
    id: "equipment",
    icon: "ShieldCheck",
    de: "Ausrüstung",
    en: "Equipment",
    items: [
      { id: "e1", de: "Helm zertifiziert (EN 1384/VG1) & unbeschädigt", en: "Helmet certified (EN 1384/VG1) & undamaged" },
      { id: "e2", de: "Helm sitzt korrekt, Riemen geschlossen", en: "Helmet fits correctly, chin strap fastened" },
      { id: "e3", de: "Sicherheitsweste / Airvest (falls genutzt) funktionsfähig", en: "Body protector / air vest (if used) functional" },
      { id: "e4", de: "Sicherheitssteigbügel / passendes Schuhwerk", en: "Safety stirrups / appropriate footwear" },
      { id: "e5", de: "Handschuhe & ggf. Gerte/Sporen situationsgerecht", en: "Gloves & (if any) whip/spurs appropriate to the situation" },
    ],
  },
  {
    id: "environment",
    icon: "Wind",
    de: "Umfeld",
    en: "Environment",
    items: [
      { id: "u1", de: "Halle/Platz: Boden ok, keine Gefahrenstellen", en: "Arena/field: footing ok, no hazards" },
      { id: "u2", de: "Wetter & Licht angemessen (Wind, Nässe, Dämmerung)", en: "Weather & light adequate (wind, wet, dusk)" },
      { id: "u3", de: "Verkehr / andere Reiter / Ablenkungen eingeschätzt", en: "Traffic / other riders / distractions assessed" },
      { id: "u4", de: "Jemand weiß, dass & wo du reitest (Notfall)", en: "Someone knows that & where you ride (emergency)" },
      { id: "u5", de: "Handy erreichbar / Notfallkontakt griffbereit", en: "Phone reachable / emergency contact at hand" },
    ],
  },
  {
    id: "rider",
    icon: "HeartPulse",
    de: "Reiter",
    en: "Rider",
    items: [
      { id: "r1", de: "Reiter-Selfcheck (IMSAFE) durchgeführt", en: "Rider self-check (IMSAFE) completed" },
      { id: "r2", de: "Körperlich fit & ausgeruht für dieses Pferd", en: "Physically fit & rested for this horse" },
      { id: "r3", de: "Mental fokussiert, kein akuter Druck/Ablenkung", en: "Mentally focused, no acute pressure/distraction" },
      { id: "r4", de: "Plan für die Einheit ist realistisch & klar", en: "Plan for the session is realistic & clear" },
    ],
  },
];

export const imsafeItems = [
  { id: "illness", letter: "I", de: "Illness – Fühle ich mich krank oder unwohl?", en: "Illness – Do I feel ill or unwell?" },
  { id: "medication", letter: "M", de: "Medication – Nehme ich Medikamente, die Reaktion/Fokus beeinflussen?", en: "Medication – Am I on medication affecting reaction/focus?" },
  { id: "stress", letter: "S", de: "Stress – Stehe ich unter starkem Druck oder Anspannung?", en: "Stress – Am I under heavy pressure or tension?" },
  { id: "alcohol", letter: "A", de: "Alcohol – Alkohol/Substanzen in den letzten 24 h?", en: "Alcohol – Alcohol/substances in the past 24 h?" },
  { id: "fatigue", letter: "F", de: "Fatigue – Bin ich übermüdet oder erschöpft?", en: "Fatigue – Am I overtired or exhausted?" },
  { id: "eating", letter: "E", de: "Eating/Emotion – Schlecht gegessen/getrunken oder emotional aufgewühlt?", en: "Eating/Emotion – Poorly fed/hydrated or emotionally shaken?" },
];

export const standards = [
  {
    id: "helmet",
    de: "Reithelm", en: "Riding Helmet",
    standardDe: "EN 1384:2023 · oder VG1 + EN 1384:2017 (mit Prüf-Kennzeichnung, z. B. BSI Kitemark) · ASTM F1163",
    standardEn: "EN 1384:2023 · or VG1 + EN 1384:2017 (with quality label, e.g. BSI Kitemark) · ASTM F1163",
    noteDe: "FEI-akzeptiert ab 01.01.2026. Nach jedem Aufprall ersetzen.",
    noteEn: "FEI-accepted from 01 Jan 2026. Replace after any impact.",
  },
  {
    id: "protector",
    de: "Sicherheitsweste (Körperprotektor)", en: "Body Protector",
    standardDe: "BETA 2018 Level 3 · EN 13158:2018 Level 3",
    standardEn: "BETA 2018 Level 3 · EN 13158:2018 Level 3",
    noteDe: "Level 3 = höchster Schutz; im Gelände/Cross empfohlen. Innenetikett prüfen.",
    noteEn: "Level 3 = highest protection; recommended cross-country. Check inner label.",
  },
  {
    id: "airvest",
    de: "Airbag-Weste (Airvest)", en: "Air Vest",
    standardDe: "Zusätzlich zum Körperprotektor, nicht als Ersatz (FEI-Sicht)",
    standardEn: "In addition to a body protector, not as a replacement (FEI view)",
    noteDe: "Auslöse-Leine & Kartusche vor jedem Ritt prüfen.",
    noteEn: "Check the trigger cord & cartridge before every ride.",
  },
  {
    id: "footwear",
    de: "Schuhwerk & Steigbügel", en: "Footwear & Stirrups",
    standardDe: "Absatz min. ~1,5 cm · Sicherheits-/Break-away-Steigbügel",
    standardEn: "Heel min. ~1.5 cm · safety / break-away stirrups",
    noteDe: "Reduziert das Risiko, im Bügel hängen zu bleiben.",
    noteEn: "Reduces the risk of getting caught in the stirrup.",
  },
];

// Curated, peer-reviewed sources (PubMed / DOI). Findings summarised neutrally.
export const sourceTopics = [
  { id: "human_factors", de: "Human Factors & Systemanalyse", en: "Human factors & systems analysis" },
  { id: "head", de: "Kopfverletzungen & Helm", en: "Head injuries & helmets" },
  { id: "protector", de: "Körperschutz & Airbag-Westen", en: "Body protection & air vests" },
  { id: "risk", de: "Sturzrisiko & Prävention", en: "Fall risk & prevention" },
  { id: "training", de: "Athletik & Training (Reiter/Pferd)", en: "Athleticism & training (rider/horse)" },
  { id: "context", de: "Stall, Transport & Umgang", en: "Stable, transport & handling" },
  { id: "para", de: "Para-Reitsport & Inklusion", en: "Para-equestrian & inclusion" },
  { id: "practice", de: "Standards & Praxis (Luftfahrt/FEI)", en: "Standards & practice (aviation/FEI)" },
];

export const sources = [
  {
    topic: "human_factors",
    authors: "Chapman M., Thomas M., Thompson K., et al.",
    year: "2022",
    title: "Human Factors Analysis and Classification System for the Equestrian Industry (HFACS-Eq): Development and Reliability",
    journal: "Safety, 8(4), 72",
    doi: "10.3390/safety8040072",
    pmid: null,
    url: "https://doi.org/10.3390/safety8040072",
    findingDe: "Überträgt das HFACS-Modell aus der Luftfahrt auf den Reitsport und führt das Pferd als eigene Gefahrenkategorie ein. Validiert (Inter-Rater-Reliabilität).",
    findingEn: "Adapts aviation's HFACS to equestrianism and adds the horse as a distinct hazard category. Validated (inter-rater reliability).",
  },
  {
    topic: "human_factors",
    authors: "Chapman M., Fenner K., Thomas M., et al.",
    year: "2025",
    title: "Lessons learnt from horse-related human fatalities: accident analysis using HFACS-Eq (Australian NCIS, 2000–2020)",
    journal: "Heliyon, 11(3), e42276",
    doi: "10.1016/j.heliyon.2025.e42276",
    pmid: "39991252",
    url: "https://doi.org/10.1016/j.heliyon.2025.e42276",
    findingDe: "50 Todesfälle analysiert: Sturz in 56 %, das Pferd in 90 % der Fälle ursächlich. Nicht-technische Fähigkeiten (Kommunikation, Führung, Aufsicht) sind entscheidend.",
    findingEn: "50 fatalities analysed: falls in 56%, the horse a causal factor in 90%. Non-technical skills (communication, leadership, supervision) are decisive.",
  },
  {
    topic: "human_factors",
    authors: "Chapman M., et al.",
    year: "2024",
    title: "The Eq-Safety Model: A Systems-Thinking Tool for Equine Health, Safety and Welfare",
    journal: "Animals, 14(23), 3450",
    doi: "10.3390/ani14233450",
    pmid: null,
    url: "https://doi.org/10.3390/ani14233450",
    findingDe: "Systemisches Denkmodell für integriertes Sicherheits- und Wohlfahrtsmanagement entlang der Triade Mensch–Pferd–Umwelt.",
    findingEn: "A systems-thinking model for integrated safety and welfare management along the human–horse–environment triad.",
  },
  {
    topic: "head",
    authors: "Bier G., Bongers M. N., Othman A., et al.",
    year: "2018",
    title: "Impact of helmet use in equestrian-related traumatic brain injury: a matched-pairs analysis",
    journal: "British Journal of Neurosurgery, 32(1), 37–43",
    doi: "10.1080/02688697.2017.1409874",
    pmid: "29205071",
    url: "https://doi.org/10.1080/02688697.2017.1409874",
    findingDe: "Reiter ohne Helm hatten ein rund 5-fach höheres relatives Risiko für intrakranielle Blutungen. Klare Empfehlung zum Helmtragen.",
    findingEn: "Unhelmeted riders had roughly a 5-fold higher relative risk of intracranial haemorrhage. Clear recommendation to wear a helmet.",
  },
  {
    topic: "head",
    authors: "Connor T. A., Clark J. M., Jayamohan J., et al.",
    year: "2019",
    title: "Do equestrian helmets prevent concussion? A retrospective analysis of head injuries and helmet damage from real-world accidents",
    journal: "Sports Medicine - Open, 5, 19",
    doi: "10.1186/s40798-019-0193-0",
    pmid: "31127396",
    url: "https://doi.org/10.1186/s40798-019-0193-0",
    findingDe: "216 Helme analysiert: 91 % der Kopfverletzungen waren Gehirnerschütterungen. Helme schützen gut vor Schädelbruch/Blutung, aber begrenzt vor Rotationskräften – Helm nach Aufprall ersetzen.",
    findingEn: "216 helmets analysed: 91% of head injuries were concussions. Helmets protect well against fractures/bleeds but less against rotational forces – replace after impact.",
  },
  {
    topic: "protector",
    authors: "Nylund L. E., Sinclair P. J., Hitchens P. L., Cobley S.",
    year: "2019",
    title: "Do riders who wear an air jacket in equestrian eventing have reduced injury risk in falls? A retrospective data analysis",
    journal: "Journal of Science and Medicine in Sport, 22(10), 1120–1125",
    doi: "10.1016/j.jsams.2019.05.012",
    pmid: "31160233",
    url: "https://doi.org/10.1016/j.jsams.2019.05.012",
    findingDe: "FEI-Daten 2015–2017: Airbag-Westen waren nicht mit geringerem Verletzungsrisiko verbunden. Airvest als Ergänzung zum zertifizierten Körperprotektor, nicht als Ersatz.",
    findingEn: "FEI data 2015–2017: air jackets were not associated with lower injury risk. Use an air vest as a complement to a certified body protector, not a replacement.",
  },
  {
    topic: "protector",
    authors: "Meyer F., et al.",
    year: "2024",
    title: "Airbag Vests in Equestrian Sports: Is Use Associated with Harm?",
    journal: "Annals of Biomedical Engineering",
    doi: "10.1007/s10439-024-03507-y",
    pmid: null,
    url: "https://doi.org/10.1007/s10439-024-03507-y",
    findingDe: "Im Labor absorbieren Airbag-Westen hohe Kräfte, im Feldeinsatz ließ sich bisher kein Verletzungsvorteil belegen. Standardisierte Prüfnormen fehlen noch.",
    findingEn: "In the lab air vests absorb high forces, yet field use has not shown an injury benefit so far. Standardised test norms are still lacking.",
  },
  {
    topic: "risk",
    authors: "Bennet E. D., Cameron-Whytock H., Parkin T. D. H.",
    year: "2023",
    title: "Horse- and rider-level risk factors associated with cross-country horse falls in eventing",
    journal: "Equine Veterinary Journal",
    doi: "10.1111/evj.13934",
    pmid: null,
    url: "https://doi.org/10.1111/evj.13934",
    findingDe: "Höheres Sturzrisiko bei höherem Leistungslevel, mehr Dressurfehlern (geringere Vorbereitung), früheren Stürzen und unerfahrenen Kombinationen – Erfahrung und Vorbereitung zählen.",
    findingEn: "Higher fall risk with higher competition level, more dressage penalties (less preparation), previous falls and inexperienced combinations – experience and preparation matter.",
  },
  {
    topic: "head",
    authors: "Davis D. J., et al.",
    year: "2024",
    title: "Traumatic brain injury and concussion in equestrian sports: a review of incidence, risk and prevention",
    journal: "PMC11569656 (review)",
    doi: null,
    pmid: null,
    url: "https://pmc.ncbi.nlm.nih.gov/articles/PMC11569656/",
    findingDe: "Übersichtsarbeit: Kopfverletzungen machen ca. 20–48 % aller reitbezogenen Verletzungen aus; das TBI-Risiko ist mit Kontaktsportarten vergleichbar oder höher.",
    findingEn: "Review: head injuries account for ~20–48% of all riding-related injuries; TBI risk is comparable to or higher than in contact sports.",
  },
  {
    topic: "training",
    authors: "Lam H. K. N., Lau W. M., Lau T. L.",
    year: "2020",
    title: "Effects of a 6-week core stabilization training program on dynamic balance and trunk stabilization endurance of horse riders",
    journal: "Sport Sciences for Health, 16, 641–650",
    doi: "10.1007/s11332-020-00729-0",
    pmid: null,
    url: "https://doi.org/10.1007/s11332-020-00729-0",
    findingDe: "6-Wochen-Rumpfstabilitäts-Training verbesserte messbar Rumpfausdauer (Biering-Sørensen) und dynamische Balance (Y-Balance). Rumpfstabilität gilt als Schlüsselfaktor gegen Stürze.",
    findingEn: "A 6-week core-stability program measurably improved trunk endurance (Biering-Sørensen) and dynamic balance (Y-Balance). Core stability is a key factor against falls.",
  },
  {
    topic: "training",
    authors: "Clayton H. M., et al.",
    year: "2017",
    title: "Effect of a 4-week elastic resistance band training regimen on back kinematics in horses",
    journal: "peer-reviewed · PubMed 28432739",
    doi: null,
    pmid: "28432739",
    url: "https://pubmed.ncbi.nlm.nih.gov/28432739/",
    findingDe: "Elastische Trainingsbänder aktivieren die Rumpf- und Hinterhandmuskulatur und reduzieren seitliches/rotatorisches Schwanken des Rückens im Trab – bessere dynamische Stabilität des Pferdes.",
    findingEn: "Elastic training bands recruit core and hindquarter muscles and reduce mediolateral/rotational sway of the back at trot – improving the horse's dynamic stability.",
  },
  {
    topic: "training",
    authors: "Williams J., et al. (Review)",
    year: "2024",
    title: "Warming up in equestrian sport: physiological rationale and practical recommendations",
    journal: "Animals, 14(6), 945",
    doi: "10.3390/ani14060945",
    pmid: null,
    url: "https://doi.org/10.3390/ani14060945",
    findingDe: "Aufwärmen erhöht Muskel-/Bluttemperatur, Herzfrequenz und Sehnenelastizität und macht das Pferd reaktiver auf Hilfen. Schon niedrig-intensives Aufwärmen ist wirksam.",
    findingEn: "Warm-up raises muscle/blood temperature, heart rate and tendon elasticity and makes the horse more responsive to aids. Even low-intensity warm-up is effective.",
  },
  {
    topic: "context",
    authors: "Trauma review (non-riding equestrian injuries)",
    year: "2014",
    title: "Non-riding (ground-handling) equestrian injuries: mechanisms and prevention",
    journal: "peer-reviewed · PMC4125461",
    doi: null,
    pmid: null,
    url: "https://pmc.ncbi.nlm.nih.gov/articles/PMC4125461/",
    findingDe: "Am Boden dominieren Tritte (Kicks) als Verletzungsursache; typisch sind Gesichts-, Bauch- und Brustverletzungen. Empfehlung: Schutz auch beim Umgang, Kick-Bereich meiden, Körpersprache lesen.",
    findingEn: "On the ground, kicks dominate as injury cause; face, abdominal and chest injuries are typical. Recommendation: protection also when handling, avoid the kick zone, read body language.",
  },
  {
    topic: "context",
    authors: "Dai F., Zappaterra M., Minero M., Bocchini F., Riley C. B., Padalino B.",
    year: "2021",
    title: "Equine Transport-Related Problem Behaviors and Injuries: A Survey of Italian Horse Industry Members",
    journal: "Animals, 11(1), 223",
    doi: "10.3390/ani11010223",
    pmid: "33477521",
    url: "https://doi.org/10.3390/ani11010223",
    findingDe: "In 50 % der Transport-Unfälle wurden Mensch UND Pferd verletzt. Risiko steigt durch Zwangsverladen (Peitsche/Sedierung) und ungeprüfte Bremsen. Habituation (ruhiges Verladetraining) senkt das Risiko.",
    findingEn: "In 50% of transport accidents both human AND horse were injured. Risk rises with forced loading (whip/sedation) and unchecked brakes. Habituation (calm loading training) lowers risk.",
  },
  {
    topic: "para",
    authors: "Fédération Équestre Internationale (FEI)",
    year: "2026",
    title: "FEI Para Dressage Rules (effective 1 January 2026) & Classification System (Grades I–V, compensating aids)",
    journal: "FEI",
    doi: null,
    pmid: null,
    url: "https://inside.fei.org/fei/disc/para-dressage/classification",
    findingDe: "Definiert Klassifizierung (Grad I–V) und die zugelassenen kompensierenden Hilfsmittel je Reiter (Master List) sowie Sicherheits-/Notfallvorgaben.",
    findingEn: "Defines classification (Grades I–V) and the approved compensating aids per rider (Master List) as well as safety/emergency provisions.",
  },
  {
    topic: "para",
    authors: "Riding for the Disabled Association (RDA)",
    year: "2025",
    title: "RDA Group & Competition Rulebook – tack safety, sidewalkers & leaders, emergency procedures",
    journal: "RDA UK",
    doi: null,
    pmid: null,
    url: "https://my-rda.org.uk/wp-content/uploads/2025/09/RDA-Group-and-Competition-Rulebook.pdf",
    findingDe: "Regelwerk für sicheres adaptives Reiten: geschulte Helfer, „stabilisieren statt tragen“, sichere Ausrüstung, Pflicht-Check nach Sturz.",
    findingEn: "Framework for safe adaptive riding: trained helpers, \u201cstabilise not carry\u201d, safe tack, mandatory post-fall check.",
  },
  {
    topic: "para",
    authors: "Hawson L. A., et al.",
    year: "2023",
    title: "Towards evidence-based classification in para-equestrian sport",
    journal: "Animals, 13(17), 2785",
    doi: "10.3390/ani13172785",
    pmid: null,
    url: "https://doi.org/10.3390/ani13172785",
    findingDe: "Plädiert für objektive, evidenzbasierte Klassifizierung – wie Impairment Leistung und Sicherheit im Para-Reitsport beeinflusst.",
    findingEn: "Argues for objective, evidence-based classification – how impairment affects performance and safety in para-equestrian sport.",
  },
  {
    topic: "practice",
    authors: "Federal Aviation Administration (FAA)",
    year: "2023",
    title: "Fit to Fly – The IMSAFE Checklist (Personal Minimums)",
    journal: "FAA Safety Briefing",
    doi: null,
    pmid: null,
    url: "https://www.faa.gov/sites/faa.gov/files/2023-10_Fit_to_Fly.pdf",
    findingDe: "Ursprung des IMSAFE-Selfchecks: standardisierte Selbsteinschätzung der eigenen Verfassung vor dem Einsatz – hier für Reiter adaptiert.",
    findingEn: "Origin of the IMSAFE self-check: a standardised self-assessment of one's condition before duty – here adapted for riders.",
  },
  {
    topic: "practice",
    authors: "Fédération Équestre Internationale (FEI)",
    year: "2026",
    title: "Accepted Testing Standards for Protective Headgear (effective 1 January 2026)",
    journal: "FEI",
    doi: null,
    pmid: null,
    url: "https://inside.fei.org/content/fei-accepted-testing-standards-protective-headgear-0",
    findingDe: "Aktuell akzeptierte Helmnormen (EN 1384:2023, VG1 + EN 1384:2017 mit Prüfsiegel, ASTM). Empfehlung: Helm alle 3–5 Jahre und nach jedem Aufprall ersetzen.",
    findingEn: "Currently accepted helmet standards (EN 1384:2023, VG1 + EN 1384:2017 with quality label, ASTM). Recommendation: replace every 3–5 years and after any impact.",
  },
];

export const factorTags = [
  { id: "communication", de: "Kommunikation", en: "Communication" },
  { id: "attention", de: "Aufmerksamkeit / Ablenkung", en: "Attention / distraction" },
  { id: "fatigue", de: "Müdigkeit / Verfassung", en: "Fatigue / condition" },
  { id: "equipment", de: "Ausrüstung / Material", en: "Equipment / gear" },
  { id: "horse_state", de: "Pferd: Stress / Schmerz", en: "Horse: stress / pain" },
  { id: "environment", de: "Umgebung / Boden / Wetter", en: "Environment / footing / weather" },
  { id: "supervision", de: "Aufsicht / Anleitung", en: "Supervision / instruction" },
  { id: "skill", de: "Können / Erfahrung", en: "Skill / experience" },
];

export const riderTraining = {
  introDe: "Deine Athletik ist Sicherheitsausrüstung. Rumpfstabilität, Balance und Reaktionsvermögen entscheiden, ob du eine Ausweichbewegung des Pferdes aussitzt oder abgeworfen wirst. Fitte Reiter stürzen seltener und verletzen sich bei Stürzen weniger schwer.",
  introEn: "Your athleticism is safety equipment. Core stability, balance and reaction time decide whether you sit a horse's evasive move or get thrown. Fitter riders fall less often and are injured less severely when they do.",
  blocks: [
    { icon: "Anchor", ref: "10.1007/s11332-020-00729-0",
      de: { t: "Rumpfstabilität (Core)", d: "2–3×/Woche Planks, Pallof-Press, Bird-Dog, Übungen auf dem Gymnastikball. Ein 6-Wochen-Programm verbesserte Rumpfausdauer & Balance messbar." },
      en: { t: "Core stability", d: "2–3×/week planks, Pallof press, bird-dog, Swiss-ball work. A 6-week program measurably improved trunk endurance & balance." } },
    { icon: "Footprints", ref: "10.1007/s11332-020-00729-0",
      de: { t: "Balance & Propriozeption", d: "Einbeinstand, Balance-Pad, Y-Balance-Übungen, Augen zu. Trainiert die schnellen Korrekturreflexe, die dich im Sattel halten." },
      en: { t: "Balance & proprioception", d: "Single-leg stance, balance pad, Y-Balance drills, eyes closed. Trains the fast corrective reflexes that keep you in the saddle." } },
    { icon: "Dumbbell", ref: null,
      de: { t: "Kraft & Beinachse", d: "Kniebeugen, Ausfallschritte, Hüftbrücke, Wadenkraft. Stabile Beinachse = sicherer Sitz und kräftiges, schnelles Aufstehen aus dem leichten Sitz." },
      en: { t: "Strength & leg line", d: "Squats, lunges, hip bridges, calf work. A stable leg line = secure seat and a strong, quick rise from light seat." } },
    { icon: "PersonStanding", ref: null,
      de: { t: "Mobilität & Beweglichkeit", d: "Hüftöffner, Brustwirbelsäulen-Rotation, Sprunggelenks-Mobilität. Beweglichkeit ermöglicht geschmeidiges, fallverträgliches Mitgehen." },
      en: { t: "Mobility & flexibility", d: "Hip openers, thoracic rotation, ankle mobility. Mobility allows supple, fall-tolerant movement with the horse." } },
    { icon: "Timer", ref: null,
      de: { t: "Reaktion & Kondition", d: "Intervall-Cardio + Reaktionsdrills (z. B. Ballfangen). Müdigkeit verschlechtert Reaktion & Urteil – Grundausdauer schützt in der letzten, kritischen Minute." },
      en: { t: "Reaction & conditioning", d: "Interval cardio + reaction drills (e.g. ball catching). Fatigue worsens reaction & judgement – base endurance protects in that last, critical minute." } },
    { icon: "Scale", ref: null,
      de: { t: "Symmetrie & Losgelassenheit", d: "Seitigkeit gezielt ausgleichen (schwächere Seite mehr trainieren). Asymmetrie stört Pferd & Gleichgewicht und erhöht das Sturzrisiko." },
      en: { t: "Symmetry & suppleness", d: "Address left/right imbalance (train the weaker side more). Asymmetry disturbs horse & balance and raises fall risk." } },
  ],
};

export const horseTraining = {
  introDe: "Ein fittes, sauber gymnastiziertes Pferd stolpert seltener, bleibt im Gleichgewicht und reagiert berechenbarer. Plötzliche Belastungssprünge und fehlendes Aufwärmen sind belegte Verletzungs-Trigger.",
  introEn: "A fit, correctly gymnasticised horse stumbles less, stays balanced and reacts more predictably. Sudden load spikes and missing warm-ups are documented injury triggers.",
  blocks: [
    { icon: "Gauge", ref: null,
      de: { t: "Trainingssteuerung (Belastung)", d: "Belastung langsam steigern – plötzliche Spitzen im Wochenpensum erhöhen nachweislich das Verletzungsrisiko in der Folgewoche. Regel: kleine, stetige Schritte." },
      en: { t: "Load management", d: "Increase load gradually – sudden spikes in weekly workload demonstrably raise injury risk the following week. Rule: small, steady steps." } },
    { icon: "Flame", ref: "10.3390/ani14060945",
      de: { t: "Aufwärmen", d: "10–15 min lösende Arbeit (viel Schritt, dann Trab/Galopp). Erhöht Muskel-/Sehnentemperatur und macht das Pferd reaktiver auf Hilfen – auch niedrig-intensiv wirksam." },
      en: { t: "Warm-up", d: "10–15 min of loosening work (lots of walk, then trot/canter). Raises muscle/tendon temperature and makes the horse more responsive – effective even at low intensity." } },
    { icon: "Activity", ref: "28432739",
      de: { t: "Rumpf & Mobilisation", d: "Karotten-Dehnungen (dynamische Mobilisation) und elastische Trainingsbänder stärken die tiefe Rückenmuskulatur (Mm. multifidi) und stabilisieren den Rücken." },
      en: { t: "Core & mobilisation", d: "Baited (dynamic) stretches and elastic training bands strengthen the deep back muscles (mm. multifidi) and stabilise the back." } },
    { icon: "Rows3", ref: null,
      de: { t: "Gymnastizierung & Stangenarbeit", d: "Cavaletti/erhöhte Stangen, Zirkel, Rückwärtsrichten, Übergänge. Verbessert Trittlänge, Balance und Körperbewusstsein – weniger Stolpern." },
      en: { t: "Gymnastics & pole work", d: "Cavaletti/raised poles, circles, backing up, transitions. Improves stride length, balance and body awareness – less stumbling." } },
    { icon: "HeartPulse", ref: null,
      de: { t: "Regeneration & Gesundheit", d: "Pausentage, Hufkontrolle, Sattelpassform, Zahn-/Rückencheck. Schmerz und Erschöpfung sind häufige, oft übersehene Auslöser für Fluchtreaktionen." },
      en: { t: "Recovery & health", d: "Rest days, hoof checks, saddle fit, dental/back checks. Pain and exhaustion are common, often-overlooked triggers of flight reactions." } },
  ],
};

export const contexts = [
  {
    id: "handling", icon: "Hand",
    de: "Bodenarbeit & Umgang", en: "Ground handling",
    tipsDe: [
      "Nie direkt hinter dem Pferd stehen – Kick-Zone meiden, seitlich arbeiten.",
      "Handschuhe tragen; Strick niemals um Hand/Körper wickeln.",
      "Körpersprache lesen (Ohren, Anspannung) und Fluchtwege freihalten.",
      "Bei jungen/nervösen Pferden auch am Boden Helm erwägen.",
    ],
    tipsEn: [
      "Never stand directly behind the horse – avoid the kick zone, work from the side.",
      "Wear gloves; never wrap the rope around your hand/body.",
      "Read body language (ears, tension) and keep escape routes clear.",
      "With young/nervous horses consider a helmet even on the ground.",
    ],
    pitfallsDe: [
      "Tritte sind am Boden die Hauptverletzungsursache – oft ins Gesicht/Bauch/Brust.",
      "Enge Boxengassen ohne Ausweichmöglichkeit.",
    ],
    pitfallsEn: [
      "Kicks are the leading ground injury cause – often to face/abdomen/chest.",
      "Narrow aisles with no room to step aside.",
    ],
  },
  {
    id: "stable", icon: "Warehouse",
    de: "Stall & Anbinden", en: "Stable & tying",
    tipsDe: [
      "Immer mit Panikhaken / Sicherheitsknoten anbinden (schnell lösbar).",
      "Auf Kopfhöhe anbinden, nicht zu lang – kein Verheddern.",
      "Ordnung: keine Mistgabeln, Kabel, Schläuche im Weg.",
      "Ruhige Routinen; Fütterungszeiten = Stresszeiten mit erhöhter Kick-Gefahr.",
    ],
    tipsEn: [
      "Always tie with a quick-release / safety knot.",
      "Tie at head height, not too long – no entanglement.",
      "Tidiness: no forks, cables, hoses in the way.",
      "Calm routines; feeding times = stress times with higher kick risk.",
    ],
    pitfallsDe: [
      "Strick zu lang oder fest verknotet → keine schnelle Befreiung.",
      "In der Box zwischen Pferd und Wand eingekeilt stehen.",
    ],
    pitfallsEn: [
      "Rope too long or hard-knotted → no quick release.",
      "Getting wedged between horse and wall inside the box.",
    ],
  },
  {
    id: "transport", icon: "Truck",
    de: "Transport & Verladen", en: "Transport & loading",
    tipsDe: [
      "Verladen in Ruhe trainieren (Habituation) – niemals mit Zwang/Peitsche.",
      "Vor jeder Fahrt: Bremsen, Boden/Gummimatten, Anhängerkupplung prüfen.",
      "Handschuhe & festes Schuhwerk; nicht neben den Reifen/Rampe stehen.",
      "Nicht ablenken lassen (kein Handy beim Führen/Fahren).",
    ],
    tipsEn: [
      "Train loading calmly (habituation) – never with force/whip.",
      "Before each trip: check brakes, floor/rubber mats, hitch.",
      "Gloves & sturdy footwear; don't stand beside the tyre/ramp.",
      "Avoid distraction (no phone while leading/driving).",
    ],
    pitfallsDe: [
      "In 50 % der Transport-Unfälle werden Mensch UND Pferd verletzt.",
      "Zwangsverladen & ungeprüfte Bremsen sind Haupt-Risikofaktoren.",
    ],
    pitfallsEn: [
      "In 50% of transport accidents both human AND horse get injured.",
      "Forced loading & unchecked brakes are major risk factors.",
    ],
  },
];

export const pitfalls = [
  { de: "Helm nach einem Sturz weiterbenutzen (statt ersetzen).", en: "Continuing to use a helmet after a fall (instead of replacing it)." },
  { de: "Airbag-Weste als Ersatz statt als Ergänzung zum Protektor sehen.", en: "Treating an air vest as a replacement rather than a complement to a body protector." },
  { de: "Trainingsintensität zu schnell steigern (Belastungsspitze).", en: "Ramping up training intensity too fast (load spike)." },
  { de: "Ohne Aufwärmen sofort in die Belastung gehen.", en: "Jumping straight into work without warming up." },
  { de: "Reiten trotz erhöhtem IMSAFE-Risiko (müde, gestresst, krank).", en: "Riding despite elevated IMSAFE risk (tired, stressed, ill)." },
  { de: "Strick/Longe um Hand oder Körper wickeln.", en: "Wrapping the rope/lunge line around hand or body." },
  { de: "Im Kick-Bereich oder direkt hinter dem Pferd stehen.", en: "Standing in the kick zone or directly behind the horse." },
  { de: "Zwangsverladen und ungeprüfte Anhänger-Bremsen.", en: "Forced loading and unchecked trailer brakes." },
  { de: "Ablenkung durch Handy beim Führen oder Fahren.", en: "Distraction by phone while leading or driving." },
];


export const paraGrades = [
  { grade: "I", de: "Schwerste Einschränkung (Rumpf & meist alle Gliedmaßen). In der Regel Schritt.", en: "Most severe impairment (trunk & usually all limbs). Typically walk only." },
  { grade: "II", de: "Schwere Rumpf-/Gliedmaßen-Einschränkung oder schwere einseitige. Schritt & Trab.", en: "Severe trunk/limb impairment or severe one-sided. Walk & trot." },
  { grade: "III", de: "Mäßige beidseitige oder schwere Arm-Einschränkung; auch gehörlose Reiter. Schritt & Trab.", en: "Moderate bilateral or severe arm impairment; also deaf riders. Walk & trot." },
  { grade: "IV", de: "Leichtere Einschränkung, Sehbeeinträchtigung (blind) oder Kleinwuchs. Alle Gangarten.", en: "Milder impairment, visual impairment (blind) or short stature. All gaits." },
  { grade: "V", de: "Geringste Einschränkung, z. B. eine Gliedmaße oder Sehbeeinträchtigung. Alle Gangarten inkl. Wechsel.", en: "Least impairment, e.g. one limb or visual impairment. All gaits incl. changes." },
];

export const adaptiveEquipment = [
  { de: "Loop-/Gummizügel & Verbindungsstege (rein bars) für eingeschränkte Griffkraft", en: "Loop/rubber reins & connecting rein bars for limited grip" },
  { de: "Haltegriff/Griffschlaufe (handhold) für mehr Stabilität", en: "Handhold / holding strap for added stability" },
  { de: "Angepasster Sattel & sichere Gurtung, ggf. Sitzverstärkung", en: "Adapted saddle & secure girthing, seat support if needed" },
  { de: "Sicherheits-/Peacock- oder Gummiband-Steigbügel, ggf. geschlossen", en: "Safety/Peacock or rubber-band stirrups, closed if needed" },
  { de: "Zwei Gerten als Ersatz für Schenkelhilfen", en: "Two whips replacing leg aids" },
  { de: "Auf-/Absteighilfe: Rampe oder Lift, gesichert", en: "Mounting aid: ramp or lift, secured" },
  { de: "Sprach-/Stimmkommandos & Caller (living letters) bei Sehbeeinträchtigung", en: "Voice commands & callers (living letters) for visual impairment" },
];

export const sidewalkerBriefing = [
  { de: "Rollen klären: 1 Leader (führt das Pferd), 1–2 Sidewalker (am Reiter)", en: "Clarify roles: 1 leader (horse), 1–2 sidewalkers (rider)" },
  { de: "Grundregel: stabilisieren, NICHT tragen – außer Auf-/Absteigen & Notfall", en: "Core rule: stabilise, do NOT carry – except mounting/dismounting & emergency" },
  { de: "Helfer geschult, körperlich fit, Mindestalter beachtet", en: "Helpers trained, physically fit, minimum age respected" },
  { de: "Hand-/Notstopp-Zeichen vor dem Aufsteigen vereinbaren", en: "Agree hand / emergency-stop signals before mounting" },
  { de: "Position: Sidewalker auf Höhe Knie/Oberschenkel, Ausweg frei", en: "Position: sidewalker at knee/thigh height, escape route clear" },
  { de: "Tempo & Übergänge an den Reiter anpassen, ständige Wachsamkeit", en: "Adapt pace & transitions to the rider, constant vigilance" },
];

export const paraEmergency = [
  { de: "Kontrolliertes Absteigen je nach Reiter vorab definieren & üben", en: "Define & rehearse a controlled dismount per rider in advance" },
  { de: "Kommunikation: gehörlos → visuelle Signale/Tafeln; blind → Caller/„living letters“", en: "Communication: deaf → visual signals/boards; blind → callers/\u201cliving letters\u201d" },
  { de: "Medizinisches beachten: Anfallsleiden, Spastik-Tagesform, Sensibilitätsstörungen (unbemerkte Druckstellen), Thermoregulation, Medikamente", en: "Mind medical factors: seizures, daily spasticity, sensory loss (unnoticed pressure sores), thermoregulation, medication" },
  { de: "Erste Hilfe erreichbar; Pflicht-Assessment nach jedem Sturz", en: "First aid reachable; mandatory assessment after every fall" },
  { de: "Notfallkontakt & Info-Karte am Reiter/Helfer", en: "Emergency contact & info card on rider/helper" },
];

export const paraPreRide = [
  { de: "Kompensierende Hilfsmittel geprüft & korrekt fixiert", en: "Compensating aids checked & correctly fastened" },
  { de: "Auf-/Absteighilfe (Rampe/Lift) bereit & gesichert", en: "Mounting aid (ramp/lift) ready & secured" },
  { de: "Helfer gebrieft & positioniert", en: "Helpers briefed & positioned" },
  { de: "Kommunikationsweg mit dem Reiter getestet", en: "Communication channel with the rider tested" },
];

export const paraAwareness = [
  { de: "Buddy-Prinzip: erfahrene Reiter als Para-Reit-Paten", en: "Buddy principle: experienced riders as para-riding mentors" },
  { de: "„Awareness-Ride“: Selbsterfahrung (einhändig / ohne Steigbügel reiten)", en: "\u201cAwareness ride\u201d: self-experience (riding one-handed / without stirrups)" },
  { de: "Hallen-Knigge: kein Überholen ohne Ansage, ruhige Hilfen, Rücksicht", en: "Arena etiquette: no overtaking without notice, quiet aids, consideration" },
  { de: "Micro-Learnings/Reels: „Was Sidewalker tun“, „Aids erklärt“", en: "Micro-learnings/reels: \u201cwhat sidewalkers do\u201d, \u201caids explained\u201d" },
  { de: "Kooperation mit RDA / Therapiereitzentren, Para-Botschafter:in im Beirat", en: "Cooperation with RDA / therapeutic riding centres, para ambassador on the board" },
  { de: "Kurs-Modul (Marken-Klasse 41): „Para-aware Reiten & Helfen“", en: "Course module (brand class 41): \u201cpara-aware riding & helping\u201d" },
];

export const socials = [
  { id: "instagram", label: "Instagram", handle: "@circleofikarus", url: "https://www.instagram.com/circleofikarus", icon: "Instagram" },
  { id: "tiktok", label: "TikTok", handle: "@circleofikarus", url: "https://www.tiktok.com/@circleofikarus", icon: "Music2" },
];

export const ASSETS = {
  logo: "/logo-mark.png",
  logoFull: "/logo-full.png",
  hero: "https://static.prod-images.emergentagent.com/jobs/8cf69369-29c0-4040-8e47-9667232887bc/images/a3b31ff99e0db07ab65fe8487109561cf3a6ff1ea67e5743faaec6af087dacd7.jpeg",
  founder: "https://static.prod-images.emergentagent.com/jobs/8cf69369-29c0-4040-8e47-9667232887bc/images/f0a77e3b8fd48a874e9fc4252dc23ba9ec647270eb23e81f0fda8c76df6dab54.jpeg",
};

export const CONTACT_EMAIL = "hallo@circleofikarus.com";
export const TRACKMYHORSE_URL = "https://trackmyhorse.org";
